import NewsletterWidget from "../../../../components/NewsletterWidget/component";

/**
 * This function handles creating a newsletter widget
 *
 * @param {Object} params the widget params
 *
 * Key properties of the @param params object
 * @param {Object} params.newsletter the newsletter object
 *
 * @returns {JSX} component structure for newsletter widget
 */

const NewsletterContainer = ({ params }) => {
    if (!params || !params.newsletter) {
        return null;
    }

    return <NewsletterWidget promotenewsletter={params.newsletter} />;
};

export default NewsletterContainer;
